import type { Tile, FormDefinition } from '@/types'
export  const tiles = [
	{ id: 'schools', label: 'Childcare & Schools', desc: 'Snacktastic menus, allergy-smart systems, right-on-time deliveries.', cta: 'Get a Quote', icon: '/assets/gfx/ym-childcare.png' },
	{ id: 'camps', label: 'Camps & Programs', desc: 'Summer fuel that survives buses, sun, and schedule chaos.', cta: 'Plan My Season', icon: '/assets/gfx/ym-camps.png' },
	{ id: 'rfp', label: 'Facilities / RFPs', desc: 'Specs, site tours, compliance docs—served hot.', cta: ' RFP / Tour', icon: '/assets/gfx/ym-facilities.png' },
	{ id: 'careers', label: 'Careers', desc: 'Make food little humans love.', cta: 'Open Roles', icon: '/assets/gfx/ym-careers.png',"link":"/careers" },
	{ id: 'vendors', label: 'Media / Vendors', desc: 'Press, partnerships, and procurement.', cta: 'Contact Us', icon: '/assets/gfx/ym-media.png' },
	{ id: 'general', label: 'General', desc: 'Not sure yet? We’ll point you right.', cta: 'Other', icon: '/assets/gfx/ym-general.png' },
];


export const forms: Record<string, FormDefinition> = {
	general: {
		title: 'Contact Us',
		fields: [
			{
				name: 'name',
				label: 'Full Name',
				required: true,
				helptext: 'Please enter your full legal name.',
				placeholder: 'John Doe',
				fieldtype: 'text',
				autocomplete: 'name',
			},
			{
				name: 'email',
				label: 'Email Address',
				required: true,
				helptext: 'We’ll only use this to contact you about your inquiry.',
				placeholder: 'john@example.com',
				fieldtype: 'email',
				autocomplete: 'email',
			},
			{
				name: 'message',
				label: 'Message',
				required: true,
				helptext: 'Provide as much detail as possible so we can help quickly.',
				placeholder: 'Your message here...',
				fieldtype: 'textarea',
			},
		],
	},

	schools: {
		title: 'Childcare & Schools Inquiry',
		submitLabel: 'REQUEST INFORMATION & PRICING',
		successMessage:
			'Thank you for contacting Yummy Catering. A member of our team will be in touch shortly to discuss your catering needs.',
		fields: [
			{ name: 'sectionContact', label: 'Contact Information', fieldtype: 'section' },
			{
				name: 'organization',
				label: 'Organization / Centre Name',
				required: true,
				placeholder: 'Organization or centre name',
				fieldtype: 'text',
				autocomplete: 'organization',
			},
			{
				name: 'contactName',
				label: 'Contact Name',
				required: true,
				placeholder: 'Jane Doe',
				fieldtype: 'text',
				autocomplete: 'name',
			},
			{
				name: 'role',
				label: 'Role / Position',
				placeholder: 'e.g. Centre Director',
				fieldtype: 'text',
				autocomplete: 'organization-title',
			},
			{
				name: 'email',
				label: 'Email Address',
				required: true,
				placeholder: 'you@example.com',
				fieldtype: 'email',
				autocomplete: 'email',
			},
			{
				name: 'phone',
				label: 'Phone Number',
				required: true,
				placeholder: '(555) 123-4567',
				fieldtype: 'tel',
				autocomplete: 'tel',
			},
			{
				name: 'city',
				label: 'City / Area',
				required: true,
				placeholder: 'City or area',
				fieldtype: 'text',
				autocomplete: 'address-level2',
			},

			{ name: 'sectionOrganization', label: 'Organization Information', fieldtype: 'section' },
			{
				name: 'organizationType',
				label: 'Type of Organization',
				required: true,
				placeholder: 'Select organization type',
				fieldtype: 'dropdown',
				options: [
					{ label: 'Non-Profit', value: 'non-profit' },
					{ label: 'Private', value: 'private' },
					{ label: 'Summer Camp', value: 'summer-camp' },
				],
			},
			{
				name: 'locations',
				label: 'Number of Locations',
				placeholder: 'e.g. 3',
				fieldtype: 'number',
				min: 1,
			},
			{
				name: 'dailyEnrollment',
				label: 'Approximate Daily Enrollment / Number of Children',
				required: true,
				placeholder: 'e.g. 120',
				fieldtype: 'number',
				min: 1,
			},

			{ name: 'sectionServices', label: 'Services Needed', fieldtype: 'section' },
			{
				name: 'services',
				label: 'What Services Are You Interested In?',
				required: true,
				helptext: 'Select all that apply.',
				fieldtype: 'checkbox-group',
				joinWith: ' + ',
				options: [
					{ label: 'A.M. Snack', value: 'am-snack' },
					{ label: 'Hot Lunch', value: 'hot-lunch' },
					{ label: 'P.M. Snack', value: 'pm-snack' },
				],
			},
			{
				name: 'targetStartDate',
				label: 'Target Start Date',
				fieldtype: 'date',
			},
			{
				name: 'cateringType',
				label: 'Type of Catering Required',
				required: true,
				fieldtype: 'radio',
				options: [
					{ label: 'Permanent Catering', value: 'permanent' },
					{ label: 'Temporary Catering', value: 'temporary' },
				],
			},

			{ name: 'sectionCurrent', label: 'Current Catering Information', fieldtype: 'section' },
			{
				name: 'usesCaterer',
				label: 'Do You Currently Use a Catering Company?',
				fieldtype: 'radio',
				options: [
					{ label: 'Yes', value: 'yes' },
					{ label: 'No', value: 'no' },
				],
			},
			{
				name: 'currentProvider',
				label: 'Current Catering Provider (Optional)',
				placeholder: 'Provider name',
				fieldtype: 'text',
				showIf: { field: 'usesCaterer', equals: 'yes' },
			},

			{ name: 'sectionContactMethod', label: 'How Would You Like Us to Contact You?', fieldtype: 'section' },
			{
				name: 'preferredContact',
				label: 'Preferred Way to Connect',
				required: true,
				helptext: 'Select all that apply.',
				fieldtype: 'checkbox-group',
				options: [
					{ label: 'Email', value: 'email' },
					{ label: 'Phone', value: 'phone' },
					{ label: 'Schedule a Site Visit at Your Centre / Location', value: 'site-visit' },
					{ label: 'Schedule a Site Visit and Tour at Our Yummy Catering Food Plant', value: 'plant-tour' },
				],
			},

			{ name: 'sectionAdditional', label: 'Additional Information', fieldtype: 'section' },
			{
				name: 'additionalInfo',
				label: 'Anything Else You Would Like Us to Know?',
				placeholder: 'Allergies, delivery constraints, timelines, anything else...',
				fieldtype: 'textarea',
				rows: 5,
			},
		],
	},
	camps: {
		title: 'Camp / Program Form',
		fields: [
			{
				name: 'campName',
				label: 'Camp / Program Name',
				placeholder: 'Name of your camp or program',
				fieldtype: 'text',
			},
			{
				name: 'email',
				label: 'Email Address',
				required: true,
				placeholder: 'you@example.com',
				fieldtype: 'email',
				autocomplete: 'email',
			},
			{
				name: 'phone',
				label: 'Phone',
				required: true,
				placeholder: '(555) 123-4567',
				fieldtype: 'text',
				autocomplete: 'tel',
			},
			{
				name: 'address1',
				label: 'Address Line 1',
				required: true,
				placeholder: '123 Main Street',
				fieldtype: 'text',
			},
			{
				name: 'address2',
				label: 'Address Line 2',
				placeholder: 'Apartment, suite, unit, etc. (optional)',
				fieldtype: 'text',
			},
			{
				name: 'city',
				label: 'City / Area',
				required: true,
				placeholder: 'City or area',
				fieldtype: 'text',
			},
			{
				name: 'preferredStartDate',
				label: 'Preferred Start Date',
				placeholder: 'e.g. July 15–20, 2025',
				fieldtype: 'date',
			},
			{
				name: 'preferredEndDate',
				label: 'Preferred End Date',
				placeholder: 'e.g. July 15–20, 2025',
				fieldtype: 'date',
			},
			{
				name: 'groupDetails',
				label: 'Group Size / Age Range',
				placeholder: 'e.g. 40 campers, ages 8–12',
				fieldtype: 'textarea',
				rows: 3,
			},
			{
				name: 'campFiles',
				label: 'Upload Info Packet / Itinerary (optional)',
				fieldtype: 'file',
				multiple: true,
				helptext: 'You can upload multiple files.',
			},
		],
	},
	vendors:{
		title: 'Vendor Inquiry',
		fields: [
			{
				name: 'inquiryType',
				label: 'Inquiry Type',
				fieldtype: 'dropdown',
				required: true,
				placeholder: 'Select an option',
				options: [
					{ label: 'Press', value: 'press' },
					{ label: 'Partnership', value: 'partnership' },
					{ label: 'Vendor', value: 'vendor' },
				]
			},
			{
				name: 'email',
				label: 'Email Address',
				fieldtype: 'email',
				required: true,
				placeholder: 'you@example.com',
			},
			{
				name: 'phone',
				label: 'Phone',
				fieldtype: 'text',
				required: true,
				placeholder: '(555) 123-4567',
			},
			{
				name: 'address1',
				label: 'Address Line 1',
				fieldtype: 'text',
				required: true,
				placeholder: '123 Main Street',
			},
			{
				name: 'address2',
				label: 'Address Line 2 (optional)',
				fieldtype: 'text',
				required: false,
				placeholder: 'Apartment, suite, unit, etc. (optional)',
			},
			{
				name: 'city',
				label: 'City / Area',
				fieldtype: 'text',
				required: true,
				placeholder: 'City or area',
			},
			{
				name: 'company',
				label: 'Company',
				fieldtype: 'text',
				required: false,
				placeholder: 'Your company name',
			},
			{
				name: 'website',
				label: 'Company Website',
				fieldtype: 'url',
				required: false,
				placeholder: 'https://example.com',
			},
			{
				name: 'description',
				label: 'Brief Description',
				fieldtype: 'textarea',
				required: false,
				placeholder: 'Tell us a bit about your inquiry...',
				rows: 4,
			},
			{
				name: 'deckFiles',
				label: 'Upload Deck (optional)',
				fieldtype: 'file',
				required: false,
				multiple: true,
			},
		],
	},
	rfp: {
		title: 'RFP Submission',
		fields: [
			{
				name: 'email',
				label: 'Email Address',
				fieldtype: 'email',
				required: true,
				placeholder: 'you@example.com',
			},
			{
				name: 'phone',
				label: 'Phone',
				fieldtype: 'text',
				required: true,
				placeholder: '(555) 123-4567',
			},
			{
				name: 'address1',
				label: 'Address Line 1',
				fieldtype: 'text',
				required: true,
				placeholder: '123 Main Street',
			},
			{
				name: 'address2',
				label: 'Address Line 2 (optional)',
				fieldtype: 'text',
				required: false,
				placeholder: 'Apartment, suite, unit, etc. (optional)',
			},
			{
				name: 'city',
				label: 'City / Area',
				fieldtype: 'text',
				required: true,
				placeholder: 'City or area',
			},
			{
				name: 'rfpDueDate',
				label: 'RFP Due Date',
				fieldtype: 'date',
				required: false,
			},
			{
				name: 'siteTour',
				label: 'Desired Site Tour Date/Time',
				fieldtype: 'datetime-local',
				required: false,
			},
			{
				name: 'rfpFiles',
				label: 'Upload RFP / Specs',
				fieldtype: 'file',
				required: false,
				multiple: true,
			},
		],
	},

}

